<template>
  <div class="distributor" v-if="distributor">
    <breadcrumbs :items="breadcrumbs">
      <div class="activation">
        <div class="distributor-action">
          <rp-status :statusInfo="distributor.activated_at"/>
        </div>

        <div class="distributor-action">
          <rp-button
            border-radius
            button-type="normal"
            @click="activateDistributor">
            {{distributorActive === 'Active' ? 'deactivate' : 'activate'}}
          </rp-button>
        </div>

        <div class="distributor-action">
          <router-link :to="{ name: 'edit-distributor', params: { id: this.$route.params.id}}">
            <rp-sprite class="create-icon" name="create"/>
          </router-link>
          <rp-sprite @click.native="activeConfirm = !activeConfirm" class="create-icon" name="delete_outline" />
        </div>
      </div>
    </breadcrumbs>

    <div class="content">
      <div class="distributor-info">
        <div class="info-group">
          <h3>Status</h3>
          <p>{{distributorActive}}</p>
        </div>
        <div class="info-group">
          <h3>First Name</h3>
          <p>{{distributor.profile.first_name ? distributor.profile.first_name : 'NOT PROVIDED'}}</p>
        </div>
        <div class="info-group">
          <h3>Last Name</h3>
          <p>{{distributor.profile.last_name ? distributor.profile.last_name : 'NOT PROVIDED'}}</p>
        </div>
        <div class="info-group">
          <h3>Email Address</h3>
          <p>{{distributor.email ? distributor.email : 'NOT PROVIDED'}}</p>
        </div>
        <div class="info-group">
          <h3>Gender</h3>
          <p>{{distributor.profile.gender | genderFilter}}</p>
        </div>
        <div class="info-group">
          <h3>Countries</h3>
          <p>{{countries}}</p>
        </div>
      </div>
    </div>

    <rp-overlay :active="activeOverlay">
        <rp-alert
          icon="done"
          :message="successMessage"
          :onClick="successFunction" />
      </rp-overlay>

    <rp-overlay :active="activeConfirm">
      <rp-delete-confirm
        icon="warning"
        userType="Distributor"
        messageType='Delete '
        :userName="userName"
        :cancel="cancelDeletion"
        :confirm="confirmDeletion" />
    </rp-overlay>

    <rp-overlay :active="activeDelete">
      <rp-alert
        icon="done"
        :message="alertMessage"
        :onClick="alertFunction" />
    </rp-overlay>

    
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import Status from 'raypro_ui/src/components/ui/Status'
import Button from 'raypro_ui/src/components/ui/inputs/Button'
import Table from 'raypro_ui/src/components/ui/Table'
import Sprite from 'raypro_ui/src/components/ui/Sprite'
import {getUserDetails, activateUser, deactivateUser, deleteUser} from 'raypro_ui/src/api/users'
import DeleteConfirm from 'raypro_ui/src/components/ui/DeleteConfirm'
import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Alert from 'raypro_ui/src/components/ui/Alert'
import page from '@/mixins/page'

export default {
  components: {
    Breadcrumbs,
    'rp-status': Status,
    'rp-button': Button,
    'rp-sprite': Sprite,
    'rp-overlay': Overlay,
    'rp-alert': Alert,
    'rp-delete-confirm': DeleteConfirm,
    'rp-table': Table
  },

  data() {
    return {
      distributor: null,
      activeOverlay: false,
      activeConfirm: false,
      activeDelete: false,
      title: 'Distributor',
      showData: false,
      update: 0
    }
  },

  mixins: [page],

  methods: {
    getUser() {
      getUserDetails(this.id).then(({data}) => {
        this.distributor = data
        this.showData = true
        this.update++
      })
    },

    successFunction() {
      this.activeOverlay = false
      this.getUser()
    },

    activateDistributor() {
      if(this.distributorActive === 'Active') {
        deactivateUser({id: this.id})
          .then(() => {
            this.activeOverlay = true
          })
          .catch(({response}) => {
            this.errors = response.errors
          })
      } else {
        activateUser({id: this.id})
          .then(() => {
            this.activeOverlay = true
          })
          .catch(({response}) => {
            this.errors = response.errors
          })
      }
    },

    alertFunction() {
      this.$router.push({name: 'all-users'})
    },

    cancelDeletion() {
      this.activeConfirm = !this.activeConfirm
    },

    confirmDeletion() {
      deleteUser({id: this.id})
        .then(() => {
          this.activeConfirm = !this.activeConfirm
          this.activeDelete = !this.activeDelete
        })
    }
  },

  mounted() {
    this.getUser()
  },

  filters: {
    genderFilter(gender) {
      switch(gender) {
      case'DISTRIBUTOR DELETED':
        return gender
      case'M':
        return 'Male'
      case'F':
        return 'Female'
      case'O':
        return 'Prefer not to say'
      default:
        return 'NOT PROVIDED'
      }
    }
  },

  props: {id: String},

  watch: {
    id: function() {
      this.getUser()
    }
  },

  computed: {
    alertMessage() {
      return `Distributor ${this.distributor.profile.first_name} ${this.distributor.profile.last_name} deleted successfully!`
    },

    userName() {
      return `${this.distributor.profile.first_name} ${this.distributor.profile.last_name}`
    },

    currentBreadcrumb() {
      return `${this.userName}`
    },

    countries() {
      const countries = this.distributor.countries.map((country) => { return country.name })

      return countries.join(', ')
    },

    breadcrumbs() {
      return [
        {
          label: 'Distributors',
          link: 'all-users'
        },
        {label: this.currentBreadcrumb}
      ]
    },

    distributorActive() {
      return this.distributor.activated_at ? 'Active' : 'Inactive'
    },

    successMessage() {
      return `Distributor ${this.distributorActive === 'Active' ? 'deactivated' : 'activated'} successfully!`
    }
  }
}
</script>

<style lang="sass">
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.activation
  display: flex
  align-items: center
  justify-content: flex-end
  .distributor-action
    margin-left: 15px
    .btn
      margin-top: 0px
      color: $color-text-invert
      border-color: $color-grey

.distributor
  .content
    display: flex
    flex-direction: column
    @include media($media-medium)
      padding: 0 40px
      flex-direction: row
      justify-content: space-between
    .distributor-info
      width: 100%
      .info-group
        display: flex
        flex-direction: column
        @include media($media-medium)
          flex-direction: row
          align-items: center
          width: 40%
        h3
          display: inline-flex
          width: 150px
          min-width: 150px
          margin: 0
          text-transform: initial
          font-weight: lighter
        p
          display: inline-flex
          line-height: 1
          font-weight: bold
          word-break: break-word

      .table-container
        flex-direction: column
        align-items: flex-start
        width: 100%
        h3
          margin: 15px 0
        .table
          margin-bottom: 15px
          width: 100%
      hr
        margin: 20px 0 36px
        border-top: 1px solid $color-grey-dark
    .modal-header
      padding: 20px
      font-size: 20px
      border-bottom: 2px solid #e2e4e4

    .modal-body
      min-height: 500px

</style>



// WEBPACK FOOTER //
// src/components/pages/Distributors/Distributor.vue